<template>
  <div>
    <div v-if="!materialsLoaded" class="text-center">
      <b-spinner label="Loading..." style="color:#002b36;"></b-spinner>
    </div>
    <b-card v-else no-body style="border:none;">
      <div v-if="(xs || (lg && !xl))" class="d-flex align-items center justify-content-center mobile-kub-dropdown-button pl-0" @click="toggleDropdownMaterial = !toggleDropdownMaterial">
        <span class="align-self-center">
          {{materialType}}
        </span>
        <b-icon icon="chevron-down" class="align-self-center ml-auto"></b-icon>
      </div>
      <b-tabs v-model="changeMaterialTabIndex" pills card vertical :nav-wrapper-class="[{'mobile-kub-dropdown-auswahl': (xs || (lg && !xl))}, {'mt-1': (xs || (lg && !xl))}, {'d-none': toggleDropdownMaterial && (xs || (lg && !xl))}, {'col-12': true}, {'col-sm-5': true}, {'col-lg-12': true}, {'col-xl-5': true}]" nav-class="kub-material-auswahl" active-tab-class="p-0 pt-3">
        <b-tab v-for="material in materials" :key="material.id" @click="selectMaterial(material.id); clearColor(); materialAccordionToggle(material.images.toggle); setMaterialType({type: material.type, code: material.code, image: material.images.pics.pic1}), setCalcMaterial({price: material.price, deliveryTime: material.delivery}), clearCalcSidesRand(), (xs || (lg && !xl)) ? toggleDropdownMaterial = !toggleDropdownMaterial : '', clearRandSides()" class="h-100">
          <template v-slot:title>
            <b-row>
              <b-col cols="8" class="pr-0">
                {{material.title}}
              </b-col>
              <b-col cols="4" class="d-flex align-items-center justify-content-end kub-icons pl-0">
                <b-img-lazy v-for="icon in material.icons" :key="icon.id" v-b-tooltip.hover :title="icon.tip" :class="{invertFilter:material.id == materialSelected}" :src="icon.src" :alt="icon.tip"></b-img-lazy>
              </b-col>
              <div class="w-100"></div>
              <b-col cols="12">
                <small class="font-weight-light">{{material.weight}}, {{material.attribute}}</small>
              </b-col>
              <div class="w-100"></div>
              <b-col cols="12" class="text-right">
                <small class="font-weight-light">ab {{formatPrice(material.price)}}/m&sup2;</small>
              </b-col>
            </b-row>
          </template>
          <b-card-text class="h-100">
            <b-container class="h-90 pb-2">
              <b-row>
                <b-col>
                  <strong class="kub-material-color-nav p-2 text-uppercase">Farben</strong>
                  <span class="kub-material-color-nav pb-2 pr-2"><small>(bitte wählen)</small></span>
                </b-col>
                <div class="w-100"></div>
                <b-col class="color pt-3 pr-0" style="min-height:150px;">
                  <ul>
                    <li v-for="(color,index) in material.colors" :key="color.id" style="cursor:pointer;" v-b-tooltip.hover :title="color.tip" @click="selectColor(index); setMaterialColor({color: color.tip, hex: color.hex, code: color.code, img: color.img})">
                      <div class="kub-color-material m-2 d-flex justify-content-center align-items-center" :style="{backgroundColor: color.hex}">
                        <b-icon icon="check" class="kub-color-check" :style="{color: color.check}" scale="1.6" v-show="index === colorSelected"></b-icon>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <div class="w-100"></div>
                <b-col>
                  <div role="tablist">
                    <b-card no-body class="mb-1" style="border:none;">
                      <b-card-header class="p-0" role="tab" style="border-bottom:none;">
                          <b-button href="#" squared block v-b-toggle="material.images.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex">
                            <span class="m-0 text-left font-weight-bold text-uppercase">Bilder</span>
                            <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                            <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                          </b-button>
                      </b-card-header>
                      <b-collapse :id="material.images.toggle" visible accordion="kub-material-accordion" role="tabpanel">
                          <b-card-body class="pt-0">
                            <b-card-text>
                              <div>
                                <b-carousel
                                  :interval="5000"
                                  controls
                                  background="white"
                                  style="text-shadow: 0px 0px 2px #000"
                                  img-height="250"
                                  img-width="250"
                                  indicators
                                >
                                  <b-carousel-slide v-for="pic in material.images.pics" :key="pic.id">
                                    <template v-slot:img>
                                      <img
                                        class="d-block img-fluid mx-auto"
                                        width="250"
                                        height="250"
                                        :src="pic.src"
                                        :alt="pic.alt"
                                      >
                                    </template>
                                  </b-carousel-slide>
                                </b-carousel>
                              </div>
                            </b-card-text>
                          </b-card-body>
                      </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1" style="border:none;">
                      <b-card-header class="p-0" role="tab" style="border-bottom:none;">
                          <b-button href="#" squared block v-b-toggle="material.desc.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex">
                            <span class="m-0 text-left font-weight-bold text-uppercase">Beschreibung</span>
                            <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                            <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                          </b-button>
                      </b-card-header>
                      <b-collapse :id="material.desc.toggle" accordion="kub-material-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text>
                              <p v-html="material.desc.text"></p>
                            </b-card-text>
                          </b-card-body>
                      </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1" style="border:none;">
                      <b-card-header class="p-0" role="tab" style="border-bottom:none;">
                          <b-button href="#" squared block v-b-toggle="material.feature.toggle" variant="link" class="kub-btn-white text-decoration-none d-flex">
                            <span class="m-0 text-left font-weight-bold text-uppercase">Eigenschaften</span>
                            <b-icon icon="plus" scale="1.5" class="align-self-center ml-auto when-closed"></b-icon>
                            <b-icon icon="dash" scale="1.5" class="align-self-center ml-auto when-opened"></b-icon>
                          </b-button>
                      </b-card-header>
                      <b-collapse :id="material.feature.toggle" accordion="kub-material-accordion" role="tabpanel">
                          <b-card-body>
                            <b-card-text class="ml-3">
                              <ul style="list-style-type: disc;">
                                <li v-for="char in material.feature.characteristics" :key="char.id" v-html="char.text"></li>
                              </ul>
                            </b-card-text>
                          </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </b-col>
              </b-row>
            </b-container>
            <b-container class="h-10">
              <b-row class="h-100 d-flex align-items-end">
                <b-col :class="[{'pr-0': true}, {'pl-0': (xs || (lg && !xl))}]">
                  <b-button type="submit" href="#" v-b-toggle="components.form.toggle" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" @click="changeStatusForm(), scrollToId('kub-heading-setup')">
                    <b-icon icon="chevron-left" font-scale="0.95"></b-icon>
                    <span class="ml-auto mr-auto">Zurück</span>
                  </b-button>
                </b-col>
                <b-col class="pr-0">
                  <b-button type="submit" href="#" v-b-toggle="components.rand.toggle" block variant="link" class="kub-btn text-decoration-none d-flex align-items-center" :disabled="materialColor.color === ''" @click="updateMaterial(), changeStatusMaterial(), scrollToId('kub-heading-draft')">
                    <span class="ml-auto mr-auto">Weiter</span>
                    <b-icon icon="chevron-right" font-scale="0.95"></b-icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import DataSetup from '../../../../../data/main/config/setup/setup'
import DataService from './../../../../../services/DataService'

import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      materials: {},
      components: DataSetup.components,
      toggleDropdownMaterial: true,
      materialsLoaded: false
    }
  },
  methods: {
    ...mapActions([
      'setMaterialType',
      'setMaterialColor',
      'clearMaterialColor',
      'setConfigMaterial',
      'changeStatusForm',
      'changeStatusMaterial',
      'clearRandSides',
      'selectColor',
      'setMaterialTabIndex',
      'selectMaterial',
      'setCalcMaterial',
      'clearCalcSidesRand',
      'materialsLoadingError'
    ]),
    materialAccordionToggle (toggleID) {
      this.$root.$emit('bv::toggle::collapse', toggleID)
    },
    clearColor () {
      this.selectColor(undefined)
      this.clearMaterialColor()
    },
    updateMaterial () {
      this.setConfigMaterial({ type: this.materialType, color: this.materialColor })
    },
    scrollToId (id) {
      if (this.lg) {
        document.getElementById('kub-heading-setup').scrollIntoView()
      } else {
        document.getElementById(id).scrollIntoView()
      }
    },
    formatPrice (grossPrice) {
      const finalPrice = this.checkVAT ? Math.round(((grossPrice / (1 + this.VATRate)) + Number.EPSILON) * 100) / 100 : grossPrice
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(finalPrice)
    }
  },
  computed: {
    ...mapGetters([
      'width',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'materialType',
      'materialTypeCode',
      'materialColor',
      'materialColorCode',
      'materialSelected',
      'colorSelected',
      'materialTabIndex',
      'checkVAT',
      'VATRate'
    ]),
    changeMaterialTabIndex: {
      get () {
        return this.materialTabIndex
      },
      set (value) {
        this.setMaterialTabIndex(value)
      }
    }
  },
  async created () {
    try {
      this.materials = await DataService.getMaterials()
      this.materialsLoaded = true
    } catch (err) {
      this.materialsLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
  .kub-icons > img {
    height: 1rem;
    width: auto;
  }

  .invertFilter {
    filter:invert(100%);
  }

  .color > ul {
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .color > ul li {
    margin: 0.1em;
    text-align: center;
    position: relative;
  }

  .color > ul li:hover {
    transition: transform 0.2s;
    transform: scale(1.2);
  }

  .kub-color-material {
    background-color: #ddd;
    width: 1.8em;
    height: 1.8em;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.125);
  }

  .kub-color-check {
    position: absolute;
  }

</style>
